import { without } from 'lodash';
import { labeled, enumRequired, numberRequired } from '../../util/joi';
import { PaymentFrequency, paymentFrequencies } from '../global/PaymentFrequency.enum';
import {
  ObjectivePayBallonOption,
  objectivePayBallonOptions
} from './ObjectivePayBallonOption.enum';
import {
  ObjectivePaymentPreferenceOption,
  objectivePaymentPreferenceOptions
} from './ObjectivePaymentPreferenceOption.enum';
import { YesNoOption, yesNoOptions } from '../global/YesNoOption.enum';

export const schema = (Joi: any, label: string) => {
  const availablePaymentFrequency = without(
    paymentFrequencies,
    PaymentFrequency.none.name,
    PaymentFrequency.weekly.name,
    PaymentFrequency.quarterly.name,
    PaymentFrequency.semiannual.name,
    PaymentFrequency.annually.name
  );
  const availableObjectivePayBallonOptions = without(
    objectivePayBallonOptions,
    ObjectivePayBallonOption.none.name
  );
  const availableObjectivePaymentPreferenceOptions = without(
    objectivePaymentPreferenceOptions,
    ObjectivePaymentPreferenceOption.none.name
  );
  const availableYesNoOptions = without(
    yesNoOptions,
    YesNoOption.none.name,
    YesNoOption.yes_discharged.name,
    YesNoOption.unsure.name
  );

  return Joi.object()
    .keys({
      loanAmount: numberRequired(Joi, 1).label(labeled(label, 'Loan amount')),
      paymentFrequency: enumRequired(
        Joi,
        availablePaymentFrequency,
        labeled(label, 'Payment frequency')
      ),
      paymentsPreference: enumRequired(
        Joi,
        availableObjectivePaymentPreferenceOptions,
        labeled(label, 'Payments preference')
      ),
      capitaliseFees: enumRequired(
        Joi,
        availableYesNoOptions,
        labeled(label, 'Capitalise fees')
      )
    })
    .when(
      Joi.object({
        balloonPercent: Joi.number().valid(1)
      }),
      {
        then: Joi.object({
          payBalloon: enumRequired(
            Joi,
            availableObjectivePayBallonOptions,
            labeled(label, 'How does the client plan to pay the balloon/residual?')
          )
        })
      }
    );
};

export default {
  schema
};
